<div [@inOutAnimation]>
  <div class="d-flex flex-row align-items-center mb-1">
    <span class="h4 mb-0 fw-bold me-2">{{review.averageRating | number: '1.1-1'}}</span>
    <app-rating-stars class="me-2"
                      [clickable]="false"
                      [ratingValue]="review.averageRating"></app-rating-stars>
    <span (click)="togglePartialRatings()"
          class="toggle-partial-ratings text-primary">
      <i-feather class="sm"
                 *ngIf="!review.showPartialRatings"
                 name="chevron-down"></i-feather>
      <i-feather class="sm"
                 *ngIf="review.showPartialRatings"
                 name="chevron-up"></i-feather>
    </span>
  </div>

  <div *ngIf="review.showPartialRatings"
       class="row mb-3"
       [@inOutAnimation]>
    <div class="col-12 col-md-8">
      <ng-container [ngTemplateOutlet]="partialGrade"
                    [ngTemplateOutletContext]="{rating:review.salonRating,
                      translation: 'SHARED.REVIEW-ITEM.PARTIAL-GRADE-SALON'}">
      </ng-container>
      <ng-container [ngTemplateOutlet]="partialGrade"
                    [ngTemplateOutletContext]="{rating:review.employeesRating,
                      translation: 'SHARED.REVIEW-ITEM.PARTIAL-GRADE-EMPLOYEE'}">
      </ng-container>
      <ng-container [ngTemplateOutlet]="partialGrade"
                    [ngTemplateOutletContext]="{rating:review.treatmentRating,
                      translation: 'SHARED.REVIEW-ITEM.PARTIAL-GRADE-TREATMENT'}">
      </ng-container>
    </div>
  </div>

  <div class="text-dark mb-1">
    <span class="me-3"
          *ngIf="review.customerFirstName">{{review.customerFirstName}}</span>
    <span class="me-3"
          *ngIf="!review.customerFirstName"
          [translate]="'SHARED.REVIEW-ITEM.GUEST'"></span>
    <span>{{review.createdOnUtc | date:'dd-MM-yyyy'}}</span>
  </div>

  <p class="mb-0 review-text"
     *ngIf="review.description">
    {{review.description}}
  </p>

  <div *ngIf="review.salonReply"
       class="ps-4 mt-3">
    <div class="review-reply ps-3">
      <div class="text-dark mb-1">
        <span class="me-3"
              [translate]="'SHARED.REVIEW-ITEM.SALON-REPLY'"></span>
        <span>{{review.salonReply.createdOnUtc | date:'dd-MM-yyyy'}}</span>
      </div>
      <p class="mb-0 review-text">
        {{ review.salonReply.replyText }}
      </p>
    </div>
  </div>
</div>

<ng-template #partialGrade
             let-rating="rating"
             let-translation="translation">
  <div class="d-flex flex-row align-items-center">
    <div class="d-flex flex-even justify-content-between align-items-center text-secondary">
      <span class="flex-even"
            [translate]="translation"></span>
      <span class="me-1 mb-0">{{rating | number: '1.0-0'}}</span>
    </div>
    <div class="flex-even d-flex flex-row align-items-center">

      <app-rating-stars [clickable]="false"
                        [ratingStarsSize]="'sm'"
                        [ratingValue]="rating"></app-rating-stars>
    </div>
  </div>
</ng-template>
